module.exports = __webpack_public_path__ + "img/MoreHeroesNeeded_Exit_x2.49bdb51d.png";